import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CButton, CForm, CFormFeedback, CFormInput, CInputGroup, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { AUTH_PATH, POPUP_REGISTER, REGEX_EMAIL } from '../../constants';
import iconLogin from '../../assets/images/iconLogin.svg';
import { iconEye, iconEyeSlash } from '../../assets/icons/custom';

import { loginRequest } from './actions';
import { setShow } from '../../actions/general';
import { fetchSubscriberLicenseesRequest } from '../CMS/Subscriber/Licensees/actions';
import { fetchSubscriberProductsRequest } from '../CMS/Subscriber/Products/actions';

const validationSchema = () =>
     Yup.object().shape({
          email: Yup.string().required('Email is required').matches(REGEX_EMAIL, 'Not a valid email'),
          password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters'),
     });

const LoginModal = () => {
     const dispatch = useDispatch();
     const navigate = useNavigate();
     const location = useLocation();
     const { token } = useParams();

     const licensees = useSelector((state) => state.subscriber.licensees);
     const products = useSelector((state) => state.subscriber.products.list);

     const [showPassword, setShowPassword] = useState(false);

     const initialValues = {
          email: '',
          password: '',
     };

     const fetchLicensees = () => {
          if (!licensees) {
               dispatch(fetchSubscriberLicenseesRequest());
          }
     };

     const fetchProducts = () => {
          if (!products.length) {
               dispatch(fetchSubscriberProductsRequest());
          }
     };
     useEffect(() => {
          fetchLicensees();
          fetchProducts();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleFormSubmit = ({ email, password }, { setSubmitting }) => {
          const loginPayload = {
               email: email.toLowerCase(),
               password,
          };

          const nextDispatch = {
               licensees,
               products,
               token,
               setSubmitting,
               navigate,
          };

          dispatch(loginRequest(loginPayload, nextDispatch));
     };

     const handleClose = () => {
          dispatch(setShow(null));
     };

     const handleToRegister = () => {
          dispatch(setShow(POPUP_REGISTER));
     };

     const handleShowPassword = () => {
          setShowPassword(!showPassword);
     };

     return (
          <CModal alignment="center" visible className="modal-login" onClose={handleClose}>
               <CModalHeader className="d-flex flex-column modal-header">
                    <img src={iconLogin} alt="Login" className="modal-title" id="exampleModalLongTitle" />
                    <h4 className="modal-title test-color-h4" id="exampleModalLongTitle">
                         Member Login
                    </h4>
                    {/* <p className="modal-title" id="exampleModalLongTitle">
                         Log in to your CAMS-care account
                    </p> */}
                    <p className="modal-title" id="exampleModalLongTitle">
                         Log in to your CAMS-care account. Please complete the RESET PASSWORD process if your login was created before March 13, 2023.
                    </p>
               </CModalHeader>
               <CModalBody>
                    <Formik
                         initialValues={initialValues}
                         validationSchema={validationSchema}
                         onSubmit={handleFormSubmit}
                         validateOnChange={false}
                         validateOnBlur={false}
                    >
                         {({ values, errors, handleSubmit, isSubmitting, setFieldValue, setFieldError }) => {
                              const handleChangeEmail = (e) => {
                                   setFieldValue('email', e.target.value.trim());
                                   setFieldError('email', undefined);
                              };

                              const handleChangePassword = (e) => {
                                   setFieldValue('password', e.target.value.trim());
                                   setFieldError('password', undefined);
                              };

                              return (
                                   <CForm className="tp-login" noValidate onSubmit={handleSubmit}>
                                        <div className="form-group d-flex flex-column">
                                             <CInputGroup className="input-custom-wrap">
                                                  <CFormInput
                                                       type="text"
                                                       placeholder="Email or username"
                                                       className="input-authen input-custom"
                                                       name="email"
                                                       autoComplete="off"
                                                       invalid={!!errors.email}
                                                       disabled={isSubmitting}
                                                       value={values.email}
                                                       onChange={handleChangeEmail}
                                                  />
                                                  <CFormFeedback invalid>{errors.email}</CFormFeedback>
                                             </CInputGroup>
                                             <CInputGroup className="input-custom-wrap input-password">
                                                  <div className="w-100 position-relative">
                                                       <CFormInput
                                                            id="password"
                                                            name="password"
                                                            type={showPassword ? 'text' : 'password'}
                                                            placeholder="Password"
                                                            className="input-authen input-custom"
                                                            autoComplete="off"
                                                            invalid={!!errors.password}
                                                            disabled={isSubmitting}
                                                            value={values.password}
                                                            onChange={handleChangePassword}
                                                       />
                                                       <CIcon
                                                            icon={!showPassword ? iconEyeSlash : iconEye}
                                                            size="xl"
                                                            className="icon-eye register"
                                                            onClick={handleShowPassword}
                                                       />
                                                  </div>

                                                  <CFormFeedback invalid> {errors.password}</CFormFeedback>
                                             </CInputGroup>
                                             <button className="btn btn-blue-highlight" type="submit" disabled={isSubmitting}>
                                                  {isSubmitting ? (
                                                       <>
                                                            Loading
                                                            <span className="dots-waiting" />
                                                       </>
                                                  ) : (
                                                       'Login'
                                                  )}
                                             </button>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                             <Link
                                                  to={{ pathname: AUTH_PATH.PASSWORD_FORGOT, state: { prevPath: location.pathname } }}
                                                  className="btn btn-link btn-reset-password"
                                             >
                                                  RESET PASSWORD
                                             </Link>
                                        </div>
                                   </CForm>
                              );
                         }}
                    </Formik>
               </CModalBody>
               <CModalFooter>
                    <CButton className="btn btn-blue-dark" onClick={handleToRegister}>
                         SIGN UP FOR FREE
                    </CButton>
               </CModalFooter>
          </CModal>
     );
};

export default LoginModal;
